import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['lat', 'log', 'map'];

  async connect() {
    if (!this.hasMapTarget) return;

    const { Map: GoogleMap } = await google.maps.importLibrary('maps');
    const { LatLng } = await google.maps.importLibrary('core');
    const position = new LatLng(
      Number.parseFloat(this.latTarget.value),
      Number.parseFloat(this.logTarget.value),
    );
    const map = new GoogleMap(this.mapTarget, {
      center: position,
      zoom: 13,
      mapTypeId: 'roadmap',
      mapId: 'SHOP_BRANCH_MAP_ID',
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
    });
    const gmpDraggable = this.hasLatTarget && this.hasLogTarget;
    const title = gmpDraggable
      ? 'このマーカーをドラッグして位置を調整できます'
      : '';
    const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');
    const draggableMarker = new AdvancedMarkerElement({
      map,
      position,
      title,
      gmpDraggable,
    });

    // マーカーのドロップ（ドラッグ終了）時のイベント
    if (gmpDraggable) {
      draggableMarker.addListener('dragend', (event) => {
        const position = draggableMarker.position;
        this.latTarget.value = position.lat;
        this.logTarget.value = position.lng;
      });
    }
  }
}
